(function () {
  Controller.$inject = [
    'AssetService',
    'AppUtils',
    'SensorService',
    '$scope',
    '$uibModal',
    '$timeout',
  ];

  const angular = window.angular;
  angular.module('app').component('monitoringKeyValue', {
    template:'<view-sidebar><view-sidebar-title><span translate>entities.asset.assetHierarchy</span></view-sidebar-title><view-sidebar-content><js-tree data="ctrl.assetsTree" multiple="true" on-select="ctrl.onSelectAsset(selected)"></js-tree><div class="absolute" ng-if="ctrl.loading"></div></view-sidebar-content></view-sidebar><div><view-sidebar-toggle></view-sidebar-toggle><div ng-hide="ctrl.keysLength(ctrl.assetsSelected) || ctrl.loading"><h1 class="no-margin centered-message"><span translate>general._select.an</span> <span translate>entities.asset.modelName</span></h1></div><div ng-class="{transparent: !ctrl.keysLength(ctrl.assetsSelected) || ctrl.loading}"><div class="panel panel-inverse" ng-repeat="asset in ctrl.assetsSelected" ng-if="asset"><header class="panel-heading"><h2>{{asset.name}}</h2><div class="panel-toolbars pull-right" ng-show="asset.selectedTags.length"><div class="panel-toolbar"><button class="btn btn-default btn-xs" ng-click="ctrl.showTagSelection(asset)" translate>buttons.add_remove</button></div><div class="panel-toolbar" style="width: 400px"><div class="row no-space"><div class="col-xs-10"><div class="row no-space"><div class="col-xs-6"><div class="input-group"><input type="text" class="form-control input-xs toolbar-input" readonly datetime-picker="dd-MM-yyyy HH:mm" is-open="ctrl.from.open" datepicker-options="ctrl.from.options" ng-click="ctrl.from.open = !ctrl.from.open" timepicker-options="ctrl.from.options" ng-model="ctrl.from.value"></div></div><div class="col-xs-6"><div class="input-group"><input type="text" class="form-control input-xs toolbar-input" readonly datetime-picker="dd-MM-yyyy HH:mm" is-open="ctrl.to.open" datepicker-options="ctrl.to.options" ng-click="ctrl.to.open = !ctrl.to.open" timepicker-options="ctrl.to.options" ng-model="ctrl.to.value"></div></div></div></div><div class="col-xs-2"><button class="btn btn-xs btn-default btn-block toolbar-btn" ng-click="ctrl.loadData(asset)" translate>buttons.load</button></div></div></div></div></header><div class="panel-body no-padding relative" style="height: 600px;"><div class="center-middle" ng-show="!asset.selectedTags.length"><button class="btn btn-default btn-lg" ng-click="ctrl.showTagSelection(asset)"><span translate>general._add._</span> <span translate>entities.sensor.modelNamePl</span></button></div><key-value-table sensors="asset.selectedTags" asset="asset" ng-if="asset.selectedTags.length" loading="asset.loading"></key-value-table><spinner show="asset.loading"></spinner></div></div></div></div><spinner show="ctrl.loading" show-logo="true" css-class="\'small\'"></spinner>',
    controller: Controller,
    controllerAs: 'ctrl',
    bindings: {
      $transition$: '<',
      assets: '<',
    },
  });

  function Controller(assetService, utils, SensorService, $scope, $uibModal, $timeout) {
    let vm = this;
    vm.$onInit = function () {
      vm.assetsTree = angular.copy(vm.assets.tree);
      vm.assets = angular.copy(vm.assets.assets);
      vm.assetsSelected = {};

      initDates();

      vm.onSelectAsset = onSelectAsset;
      vm.showTagSelection = showTagSelection;

      vm.loadData = loadData;

      vm.keysLength = function (obj) {
        return Object.keys(obj).length;
      };
    };

    function onSelectAsset(selected) {
      $timeout(function () {
        if (!Array.isArray(selected) || selected.length === 0) {
          vm.assetsSelected = {};
          return;
        }

        let removeUnselected = function () {
          for (let assetId in vm.assetsSelected) {
            let exist = selected.find((current) => current === assetId);
            if (!exist) {
              delete vm.assetsSelected[assetId];
            }
          }
        };

        let count = 0;
        let notLoaded = selected.filter(function (assetId) {
          return vm.assetsSelected[assetId] === undefined;
        });

        if (notLoaded.length) {
          vm.loading = true;
          notLoaded.forEach(function (assetId) {
            vm.assetsSelected[assetId] = null;
            assetService
              .findById(assetId, {
                include: {
                  relation: 'sensors',
                  scope: {
                    fields: ['id', 'name', 'type', 'enabled', 'unit'],
                  },
                },
                fields: ['id', 'name', 'customerId', 'currentStateId'],
              })
              .then(function (asset) {
                vm.assetsSelected[assetId] = asset;
                count++;
                if (count === notLoaded.length) {
                  removeUnselected();
                  vm.loading = false;
                }
              })
              .catch(function (err) {
                console.log(err);
                count++;
                delete vm.assetsSelected[assetId];
                if (count === notLoaded.length) {
                  removeUnselected();
                  vm.loading = false;
                }
              });
          });
        } else {
          removeUnselected();
        }
      });
    }

    function showTagSelection(asset) {
      let instance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        bindToController: true,
        component: 'assetTagSelection',
        size: 'lg',
        resolve: {
          asset: () => asset,
          supportedTypes: () => [
            'CrossLineMultiRecognition',
            'FaceDetection',
            'FaceMaskDetection',
            'NaiveSocialDistancing',
            'Number',
            'ObjectCounting',
            'ObjectRecognition',
            'ObjectRecognitionNumeric',
            'GranularityDetection',
            'PoseDetection',
            'SpeedChange',
            'StoppedObjectsDetector',
            'StoppedLicensePlate',
          ],
        },
      });

      instance.result
        .then(function (result) {
          asset.selectedTags = result;
          loadData(asset);
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function loadData(asset) {
      asset.loading = true;
      let count = 0;
      const data = [];

      const from = vm.from.value;
      let to = vm.to.value;

      if (from > to || Math.abs(to - from) > 24 * 60 * 60 * 1000) {
        to = new Date(from.getTime());
        to.setTime(from.getTime());
        to.setHours(to.getHours() + 24);
        vm.to.value = to;
      }

      for (let i = 0; i < asset.selectedTags.length; i++) {
        const sensor = asset.selectedTags[i];
        $timeout(() => {
          SensorService.getData(sensor.id, { from: from, to: to })
            .then((result) => {
              sensor.data = result;
              count++;
              if (count === asset.selectedTags.length) {
                asset.loading = false;
              }
            })
            .catch((err) => {
              console.log(err);
              count++;
              if (count === asset.selectedTags.length) {
                asset.loading = false;
              }
            });
        }, i * 300);
      }
    }

    function initDates() {
      const toDate = new Date();
      const fromDate = new Date();

      toDate.setHours(toDate.getHours() + 1);
      fromDate.setHours(fromDate.getHours() - 11);

      vm.from = {
        value: fromDate,
        open: false,
        options: {
          showWeeks: false,
          showMeridian: false,
        },
      };

      vm.to = {
        value: toDate,
        open: false,
        options: {
          showWeeks: false,
          showMeridian: false,
        },
      };
    }
  }
})();
